export enum PartnerCalendarStatus {
	AVAILABLE = "available",
	NOT_AVAILABLE = "not_available",
	ADAM = "job_with_adam",
}

export const PARTNER_CALENDAR_STATUS_COLORS: Record<
	PartnerCalendarStatus | string,
	string
> = {
	[PartnerCalendarStatus.AVAILABLE]: "#10b981", // Emerald-500
	[PartnerCalendarStatus.NOT_AVAILABLE]: "#ef4444", // Red-500
	[PartnerCalendarStatus.ADAM]: "#0ea5e9", // Sky-500
};

export const PARTNER_CALENDAR_STATUS_LABELS: Record<
	PartnerCalendarStatus | string,
	string
> = {
	[PartnerCalendarStatus.AVAILABLE]: "AVL",
	[PartnerCalendarStatus.NOT_AVAILABLE]: "N/A",
	[PartnerCalendarStatus.ADAM]: "Job with Adam",
};

export type PartnerBooking = {
	orderId: number;
	orderPrice: number;
	duration: number;
	dayOfJob: number;
};

export type PartnerAvailability = {
	date: string; // ISO date string YYYY-MM-DD
	status: PartnerCalendarStatus;
	isBlocked?: boolean;
	capacity?: number;
	bookings?: PartnerBooking[];
};

export type PartnerVerticalWithLevel = {
	name: string;
	level: string;
};

export type PartnerCalendarRowData = {
	partner: {
		id: number;
		name: string;
		email: string;
		phone: string;
		verticals: PartnerVerticalWithLevel[];
		confirmedJobsCount: number;
		inProgressJobsCount: number;
	};
	availability: Record<string, PartnerAvailability>; // key is date string
};
